const appDevSteps = [
  {
    number: "01",
    title: "Konzept & Planung",
    description: "In einem intensiven Abstimmungsprozess analysieren wir Ihre Zielgruppe und definieren die Kernfunktionen Ihrer App. Wir erstellen ein detailliertes Pflichtenheft und einen agilen Projektplan, der technologische Trends, Sicherheitsanforderungen und Skalierbarkeit berücksichtigt.",
  },
  {
    number: "02",
    title: "UI/UX Design",
    description: "Unsere erfahrenen Designer entwickeln durchdachte Wireframes und interaktive Prototypen. Unter Einsatz moderner Designprinzipien wie Responsive Design und Material Design optimieren wir die Benutzerführung und schaffen ein ansprechendes, konsistentes visuelles Erlebnis.",
  },
  {
    number: "03",
    title: "Entwicklung",
    description: "Unsere Entwickler programmieren Ihre App mit modernen Technologien und Frameworks, um eine robuste, sichere und skalierbare Anwendung zu gewährleisten. Durch den Einsatz von Continuous Integration, automatisierten Tests und Clean-Code-Prinzipien sichern wir eine hohe Codequalität und schnelle Iterationen.",
  },
  {
    number: "04",
    title: "Test & Launch",
    description: "In umfangreichen Testphasen – inklusive Unit-, Integrations- und Usability-Tests – optimieren wir Performance und Stabilität. Nach dem erfolgreichen Launch in den relevanten App Stores bieten wir kontinuierlichen Support, regelmäßige Updates und Performance-Monitoring, um den langfristigen Erfolg Ihrer App sicherzustellen.",
  },
];

export default appDevSteps;
